import { Component } from '@angular/core'

@Component({
  standalone: false,
  selector: 'app-subfooter',
  templateUrl: './subfooter.component.html',
  styleUrls: ['./subfooter.component.scss']
})
export class SubfooterComponent {}
